import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const TinyMCE = ({ values, handleInputChange, name, id }) => {
  const [value, setValue] = React.useState(values ?? "");
  const [length, setLength] = React.useState(0);

  const handleInit = (evt, editor) => {
    setLength(editor.getContent({ format: "text" }).length); //A method for retrieving the character count in the textarea
  };

  const handleUpdate = (content, editor) => {
    const length = editor.getContent({ format: "text" }).length;
    handleInputChange({ target: { name: name, value: content, id: id } });
    setValue(content);
    setLength(length);
  };

  return (
    <>
      {
        <Editor
          apiKey={process.env.API_KEY_TINY}
          name="subdescription"
          value={value}
          onInit={handleInit}
          onEditorChange={handleUpdate}
          init={{
            body_class: "pgi-tiny-editor-content",
            menubar: true,
            plugins: ["media", "table", "autolink", "link", "quickbars"],
            toolbar:
              "undo redo | formatselect | quicklink" +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent " +
              "quicklink link image removeformat | help" +
              "table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow " +
              "tableinsertcolbefore tableinsertcolafter tabledeletecol" +
              "media",
            content_css: "/tinyEditorStyles/tiny_editor.css" // En el proyecto, url completa del archivo referenciado: http://localhost:3000/tinyEditorStyles/tiny_editor.css
          }}
        />
      }
    </>
  );
};

export default TinyMCE;
